module.exports = __webpack_public_path__ + "img/news1.d05c4bbe.jpg";